import { createApp } from "vue";
import App from "./App.vue";

import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";

import vuetify from "./plugins/vuetify";
import message from "./plugins/message";
import confirm from "./plugins/confirm";
import router from "./router";
import store from "./store";
import VueCookies from "vue3-cookies";
import CKEditor from "@ckeditor/ckeditor5-vue";

String.prototype.trunc =
	String.prototype.trunc ||
	function(n) {
		return this.length > n ? this.substr(0, n - 1) + "..." : this;
	};

const app = createApp(App);

app.use(store);
app.use(vuetify);
app.use(message);
app.use(confirm);
app.use(CKEditor);
app.use(VueCookies, { expireTimes: "1d" });

store
	.dispatch("fetchUser")
	.catch(() => undefined)
	.finally(() => {
		app.use(router);
		app.mount("#app");
	});
